import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { toast } from "./ui/sonner";
import { Loader2 } from "lucide-react";
import { LeadFields, emptyLeadForm, leadBodyFromForm, validateLeadPhones } from "./LeadFields";

/* 新增客户线索（字段与「编辑客户信息」完全一致，共用 LeadFields） */
export const LeadForm = ({ open, onClose, meta, onCreated }) => {
  const { api, lang, user } = useApp();
  const zh = lang === "zh";
  const isSales = user?.role === "sales";
  const selfName = user?.salesName || user?.name || user?.username || "";
  const [form, setForm] = useState(() => emptyLeadForm(meta, isSales ? selfName : ""));
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!form.firstName && !form.lastName) { toast.error(zh ? "请填写客户姓名" : "Name required"); return; }
    if (!form.branch) { toast.error(zh ? "请选择所属分公司" : "Branch required"); return; }
    /* SYS-001：电话必须符合 NNN-NNN-NNNN，且同一客户内不能重复；跨客户重名由后端查重拦截 */
    const phoneErr = validateLeadPhones(form, [], zh);
    if (phoneErr) { toast.error(phoneErr); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/crm/leads", { ...leadBodyFromForm(form), assignedSales: isSales ? selfName : form.assignedSales });
      toast.success(zh ? "客户已创建" : "Lead created");
      setForm(emptyLeadForm(meta, isSales ? selfName : ""));
      onCreated?.(data);
    } catch (e) { toast.error(e?.response?.data?.detail || (zh ? "创建失败" : "Failed")); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl max-h-[88vh] overflow-y-auto" data-testid="lead-form-dialog">
        <DialogHeader>
          <DialogTitle>{zh ? "新增客户线索" : "New Lead"}</DialogTitle>
          <DialogDescription>{zh ? "登记客户基础信息、来源与需求，创建后进入销售流程" : "Register basic info, source and needs; the lead enters the sales process after creation"}</DialogDescription>
        </DialogHeader>
        <LeadFields form={form} setForm={setForm} meta={meta} zh={zh} tid="lead" lockSales={isSales} selfName={selfName} />
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose}>{zh ? "取消" : "Cancel"}</Button>
          <Button data-testid="lead-form-submit" onClick={submit} disabled={busy} className="bg-indigo-600 hover:bg-indigo-700 text-white">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : (zh ? "创建" : "Create")}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LeadForm;
